import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { AppFooterComponent } from './AppFooterComponent';
import { AppViewComponent } from './AppViewComponent';
import { ViewContainerWrapper } from './BasicViewContainer';
import { FramedAppHeader } from './FramedAppHeader';
import { useViewContainer } from './useViewContainer';
import { LayoutTemplateViewContainer } from './LayoutTemplateViewContainer';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { SignupEmbedderOptions } from 'signup-embedder';
export const FramedViewContainer = () => {
  const {
    ViewComponent,
    viewContainerProps
  } = useViewContainer();
  const {
    shouldUseLayoutTemplate
  } = useLayoutTemplate();
  const showProgressIndicator = Boolean(SignupEmbedderOptions.getOptionValue(SignupEmbedderOptions.SIGNUP_SHOW_PROGRESS_INDICATOR_OPTION));

  if (!ViewComponent) {
    return null;
  }

  if (shouldUseLayoutTemplate) {
    return /*#__PURE__*/_jsx(ThemeProvider, {
      theme: {
        embedded: true
      },
      children: /*#__PURE__*/_jsx(LayoutTemplateViewContainer, Object.assign({
        showAccountLink: false,
        showLogo: false,
        showProgressIndicator: showProgressIndicator,
        StepViewComponent: ViewComponent
      }, viewContainerProps))
    });
  }

  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: {
      embedded: true
    },
    children: /*#__PURE__*/_jsxs(ViewContainerWrapper, Object.assign({}, viewContainerProps, {
      children: [/*#__PURE__*/_jsx(FramedAppHeader, {}), /*#__PURE__*/_jsx(AppViewComponent, {
        StepViewComponent: ViewComponent
      }), /*#__PURE__*/_jsx(AppFooterComponent, {})]
    }))
  });
};